import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Close from 'mdi-react/CloseCircleOutlineIcon';
import { partial } from '../../../util/translation/translation';
import QuestionForm from './QuestionForm';
import { questionValueToPayload } from './utils';

const EditQuestionModal = ({
  showModal,
  onClose,
  editableQuestion,
  onSave,
  showValidAnswerCheckbox,
  allowedTypes,
}) => {
  const qT = partial('question');

  const promptTitle = editableQuestion ? qT('edit') : qT('addBtn');
  const handleSubmit = (values, questionValue) => {
    // Ensure only one option is marked as valid for RADIO_BUTTONS
    const overallType = values?.type?.value || editableQuestion?.type;
    let sanitizedValue = questionValue;
    if (
      Array.isArray(questionValue) &&
      (questionValue[0]?.type === 'RADIO_BUTTONS' ||
        overallType === 'RADIO_BUTTONS')
    ) {
      const firstValidIndex = questionValue.findIndex(
        (opt) => opt.isValidAnswer
      );
      sanitizedValue = questionValue.map((opt, idx) => ({
        ...opt,
        isValidAnswer: idx === firstValidIndex,
      }));
    }
    const payload = {
      id: editableQuestion?.id,
      type: values.type.value,
      description: values.description,
      imageUrl:
        values?.headingImage?.croppedBase64 || values?.headingImage?.preview,
      title: values.title,
      value: questionValueToPayload(sanitizedValue, values.type.value),
      isRequired: values.isRequired,
      imageHeaderType: values?.imageHeaderType?.value,
      headingVideos: values?.headingVideos || [],
      pointValue: values?.pointValue,
    };
    onSave(payload);
  };

  return (
    <Modal
      modalClassName="question-modal"
      isOpen={!!showModal}
      toggle={onClose}
    >
      <ModalHeader className="navbar-modal-header">
        <div className="modal-header-title">{promptTitle}</div>
        <div className="float-right">
          <button className="marginBottom-0 builder-button" onClick={onClose}>
            <Close />
          </button>
        </div>
      </ModalHeader>
      <ModalBody>
        <QuestionForm
          type={editableQuestion ? 'edit' : 'create'}
          question={editableQuestion}
          onSubmit={handleSubmit}
          onClose={onClose}
          showValidAnswerCheckbox={showValidAnswerCheckbox}
          allowedTypes={allowedTypes}
        />
      </ModalBody>
    </Modal>
  );
};
export default EditQuestionModal;
